export default "__VITE_ASSET__50mhr_ko__"